import { categoryListAction } from "./pricingSetupCategoryAction";

const initialState = {
  loading: false,
  formSetuCtegory: [],
  error: "",
};

const pricingFormSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case categoryListAction.SETUP_CATEGORY_LIST:
      return {
        ...state,
        formSetuCtegory: action.payload,
      };

    case categoryListAction.SETUP_CATEGORY_LIST_ERROR:
      return {
        ...state,
        formSetuCtegory: [],
        error: action.payload,
      };

    default:
      return {
        state,
      };
  }
};

export default pricingFormSetupReducer;
